export default "__VITE_PUBLIC_ASSET__8568603f__"